import { ProgressBarLink } from "@/components/progress-bar";

import { clickableText, cx } from "@/lib/tailwind-utils";

export function ProviderServiceHint({ className }: { className?: string }) {
  return (
    <p className={cx("text-caption text-muted-foreground", className)}>
      Don&apos;t see the provider you&apos;re looking for? Make sure
      they&apos;re{" "}
      <ProgressBarLink
        href="/settings/services"
        className={cx(clickableText, "!text-caption")}
      >
        assigned to a service.
      </ProgressBarLink>
    </p>
  );
}
